<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<h1 class="toc"><span class="bold"><a id="page5">contents</a></span></h1><a id="page5">
</a><p class="toc"><a id="page5"></a><a href="#/cap01#ch01">COOKIE BASICS</a></p>
<p class="toc"><span href="#/cap02#ch02" title="Link target outside of Sample">DROP COOKIES</span></p>
<p class="toc"><span href="#/cap03#ch03" title="Link target outside of Sample">SANDWICH COOKIES &amp; BARS</span></p>
<p class="toc"><span href="#/cap04#ch04" title="Link target outside of Sample">HOLIDAY COOKIES</span></p>
<p class="toc"><span href="#/index" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3ee9e162